// This will be the file for javascript

(function(){
    // Slideshow Section slider code
    function initSlideshowSwipers() {
        let slideshowWrapper = document.querySelectorAll('.hero-slideshow__wrapper');

        slideshowWrapper.forEach(wrapper => {
        let id = wrapper.getAttribute('data-section-id');
        let autoSlides = wrapper.getAttribute('data-auto-slide');
        let slideDuration = parseInt(wrapper.getAttribute('data-slide-duration')) || 2500;
        let pagination = wrapper.querySelector('.swiper-pagination')

        let swiperContainer = document.querySelector('#slideshow-' + id);
        if (swiperContainer) {
            if (swiperContainer.swiper) {
            swiperContainer.swiper.destroy();
            }

            let swiperOptions = {
            slidesPerView: 1,
            effect: 'fade',
            speed: 1000,
            loop: true,
            pagination: {
                el: pagination,
                clickable: true,
            },
            };
            if (autoSlides === 'true') {
            swiperOptions.autoplay = {
                delay: slideDuration,
                disableOnInteraction: false,
            };
            }
            let swiper = new Swiper('#slideshow-' + id, swiperOptions);
        }
        });
    }

    // Featured tab collection
    // function featuredCollectionTabbed() {
    //    const swipers = [];
    //     document.querySelectorAll('.collection-swiper').forEach((swiperEl, index) => {
    //         const swiper = new Swiper(swiperEl, {
    //         slidesPerView: 1.1,
    //         spaceBetween: 12,
    //         draggable: true,
    //         navigation: {
    //             nextEl: '.swiper-button-next',
    //             prevEl: '.swiper-button-prev',
    //         },
    //         breakpoints: {
    //             769: { slidesPerView: 2.1 },
    //             990: { slidesPerView: 3.1 },
    //             1201: { slidesPerView: 4.1 },
    //         },
    //         });
    //         swipers.push(swiper);
    //     });

    //     const tabs = document.querySelectorAll('.featured-tab__item');
    //     const tabContents = document.querySelectorAll('.tab-content');

    //     tabs.forEach(tab => {
    //         tab.addEventListener('click', () => {
    //         tabs.forEach(t => t.classList.remove('active'));
    //         tab.classList.add('active');
    //         const target = tab.getAttribute('data-tab');
    //         tabContents.forEach(c => c.classList.remove('active'));
    //         document.getElementById(target).classList.add('active');

    //         swipers.forEach(sw => sw.update());
    //         });
    //     });
    // }

    // function featuredCollectionTabbed() {
    //     const tabs = document.querySelectorAll('.featured-tab__item');
    //     const tabContents = document.querySelectorAll('.tab-content');

    //     let activeSwiper = null;
    //     const swipers = {};

    //     function initSwiper(swiperContainer) {
    //         return new Swiper(swiperContainer, {
    //         slidesPerView: 1.1,
    //         spaceBetween: 12,
    //         breakpoints: {
    //             769: { slidesPerView: 2.1 },
    //             990: { slidesPerView: 3.1 },
    //             1201: { slidesPerView: 4.1 },
    //         }
    //         });
    //     }

    //     function activateTab(tabBtn) {
    //         const targetID = tabBtn.getAttribute('data-tab');
    //         const content = document.getElementById(targetID);

    //         tabs.forEach(t => t.classList.remove('active'));
    //         tabBtn.classList.add('active');
    //         tabContents.forEach(c => c.classList.remove('active'));
    //         content.classList.add('active');

    //         if (!swipers[targetID]) {
    //         const swiperEl = content.querySelector('.collection-swiper');
    //         swipers[targetID] = initSwiper(swiperEl);
    //         }

    //         activeSwiper = swipers[targetID];

    //         const prevBtn = document.querySelector('.featured-tabs__nav .swiper-prev');
    //         const nextBtn = document.querySelector('.featured-tabs__nav .swiper-next');

    //         prevBtn.onclick = () => activeSwiper.slidePrev();
    //         nextBtn.onclick = () => activeSwiper.slideNext();

    //         setTimeout(() => {
    //         activeSwiper.update();
    //         }, 50);
    //     }

    //     activateTab(tabs[0]);

    //     tabs.forEach(tab => {
    //         tab.addEventListener('click', () => activateTab(tab));
    //     });
    // }
    function featuredCollectionTabbed() {
        const tabs = document.querySelectorAll('.featured-tab__item');
        const tabContents = document.querySelectorAll('.tab-content');

        let activeSwiper = null;
        const swipers = {};

        function initSwiper(swiperContainer) {
            return new Swiper(swiperContainer, {
                slidesPerView: 1.1,
                spaceBetween: 12,
                allowTouchMove: true,
                breakpoints: {
                    769: { slidesPerView: 2.1 },
                    990: { slidesPerView: 3.1 },
                    1201: { slidesPerView: 4.1 },
                }
            });
        }

        function updateArrowState(swiper, prevBtn, nextBtn) {
            if (swiper.isBeginning) {
                prevBtn.classList.add('disabled');
            } else {
                prevBtn.classList.remove('disabled');
            }
            if (swiper.isEnd) {
                nextBtn.classList.add('disabled');
            } else {
                nextBtn.classList.remove('disabled');
            }
            if (swiper.slides.length <= swiper.params.slidesPerView) {
                prevBtn.classList.add('disabled');
                nextBtn.classList.add('disabled');
            }
        }

        function activateTab(tabBtn) {
            if (tabBtn) {
                const targetID = tabBtn.getAttribute('data-tab');
                const content = document.getElementById(targetID);

                tabs.forEach(t => t.classList.remove('active'));
                tabBtn.classList.add('active');
                tabContents.forEach(c => c.classList.remove('active'));
                content.classList.add('active');

                if (!swipers[targetID]) {
                    const swiperEl = content.querySelector('.collection-swiper');
                    swipers[targetID] = initSwiper(swiperEl);
                }

                activeSwiper = swipers[targetID];

                const prevBtn = document.querySelector('.featured-tabs__nav .swiper-prev');
                const nextBtn = document.querySelector('.featured-tabs__nav .swiper-next');

                prevBtn.onclick = () => {
                    activeSwiper.slidePrev();
                };
                nextBtn.onclick = () => {
                    activeSwiper.slideNext();
                };

                setTimeout(() => {
                    activeSwiper.update();
                    updateArrowState(activeSwiper, prevBtn, nextBtn);
                }, 50);

                activeSwiper.on('slideChange', () => {
                    updateArrowState(activeSwiper, prevBtn, nextBtn);
                });
            }
        }

        activateTab(tabs[0]);

        tabs.forEach(tab => {
            tab.addEventListener('click', () => activateTab(tab));
        });
    }


    // FAQ Tabs section
    function faqTabs() {
        const faqSections = document.querySelectorAll('.faq-section__banner');

        faqSections.forEach(section => {
            const tabs = section.querySelectorAll('.faq-tab__item');
            const contents = section.querySelectorAll('.faq-accordion__content');

            if (!tabs.length || !contents.length) return;

            tabs.forEach((tab, index) => {
            tab.addEventListener('click', function () {
                tabs.forEach(t => t.classList.remove('active'));
                contents.forEach(c => c.classList.remove('active'));
                tab.classList.add('active');
                contents[index].classList.add('active');
            });
            });
        });

        const grid = document.querySelector(".faq-tabs__grid");
        const prevBtn = document.querySelector(".tab-nav__prev");
        const nextBtn = document.querySelector(".tab-nav__next");
        const tabs = document.querySelectorAll(".faq-tab__item");
        if (!grid) return;
        const scrollAmount = 150;
        nextBtn?.addEventListener("click", () => {
            grid.scrollBy({
            left: scrollAmount,
            behavior: "smooth"
            });
        });
        prevBtn?.addEventListener("click", () => {
            grid.scrollBy({
            left: -scrollAmount,
            behavior: "smooth"
            });
        });
    }

    // Annoucement bar slider desktop
    function initAnnouncementBar() {
        let announcementBarWrapper = document.querySelectorAll('.utility-bar ');

        announcementBarWrapper.forEach(wrapper => {
            if(wrapper) {
                let id = wrapper.getAttribute('data-section-id');
                let swiperContainer = document.querySelector('#utility-bar-' + id);
                if (swiperContainer) {
                    if (swiperContainer.swiper) {
                    swiperContainer.swiper.destroy();
                    }

                    let swiperOptions = {
                        slidesPerView: 3,
                        speed: 1000,
                        draggable: true,
                        loop: true,
                    };
                    let swiper = new Swiper('#utility-bar-' + id, swiperOptions);
                }
            }

        });
    }

    // Tidio Live chat Widget
    function closeTidio() {
        if (window.tidioChatApi) {
            window.tidioChatApi.close();
        } else {
            document.addEventListener("tidioChat-ready", function () {
                window.tidioChatApi.close();
            });
        }
    }
    function tidioLiveWidget() {
        function openTidioChat() {
            if (window.tidioChatApi) {
                window.tidioChatApi.open();
            } else {
                document.addEventListener("tidioChat-ready", function() {
                window.tidioChatApi.open();
                });
            }
        }
        const liveChatBtn = document.querySelector(".open-tidio-chat");
        if (liveChatBtn) {
            liveChatBtn.addEventListener("click", function(e) {
                e.preventDefault();
                openTidioChat();
            });
        }
    }

    function menuToggleMobile() {
        const menuButtons = document.querySelectorAll('.menu-drawer__dropdown');
        menuButtons.forEach(btn => {
            if (btn) {
                btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    const dropdown = this.nextElementSibling;
                    dropdown.classList.toggle('open');
                    this.classList.toggle('open');
                });
            }

        });
    }


    document.addEventListener('DOMContentLoaded', () => {
        initSlideshowSwipers();
        featuredCollectionTabbed();
        faqTabs();
        initAnnouncementBar();
        closeTidio();
        tidioLiveWidget();
        menuToggleMobile();
    });

})();